import axios from "axios";
import ENV from "../env";

const options = {
    headers: {
        'Content-Type': 'application/json',
        'Security': `${ENV.REACT_APP_SECURE_TOKEN}`
    }
};

const loginApi = async (body) => {

    const response = await axios.post(`${ENV.LOCUSB_API}/UserSignInOut`, body, options)

    if (response.data.success === 'false') {
        return response.data.errorMsg
    }
    else {
        return response.data;
    }
}

export default loginApi;
